import { t } from '../../../i18n/strings.js';

// Seção de garantia dedicada, maior que o selinho do seletor. Texto sem
// promessa absoluta: a elegibilidade segue os termos da garantia.
export default function GuaranteeSection() {
  return (
    <section className="rounded-[22px] bg-surface border border-cyan/30 p-5 flex flex-col items-center text-center">
      <img
        src="/guarantee-seal.png"
        alt={t('paywallIntl.guaranteeSectionTitle')}
        width={128}
        height={128}
        loading="lazy"
        className="w-32 h-32 object-contain"
      />
      <h2 className="font-display font-extrabold text-[24px] leading-tight mt-3">{t('paywallIntl.guaranteeSectionTitle')}</h2>
      <p className="text-[14px] text-ink-muted mt-2">{t('paywallIntl.guaranteeSectionBody')}</p>
    </section>
  );
}
